module.exports = __webpack_public_path__ + "img/sloat-nolimit.53cbef99.jpg";